/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_Slug_PlaceholderInputs */

const en_admin_categories_slug_placeholder = /** @type {(inputs: Admin_Categories_Slug_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. tutorials`)
};

/**
* | output |
* | --- |
* | "e.g. tutorials" |
*
* @param {Admin_Categories_Slug_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_categories_slug_placeholder = /** @type {((inputs?: Admin_Categories_Slug_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_Slug_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_categories_slug_placeholder(inputs)
});
export { admin_categories_slug_placeholder as "admin.categories.slug_placeholder" }